import { defineStore } from 'pinia'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import ThumbCell from '@/onenetwork/components/datatable/ThumbCell.vue'
import DateTimeCell from '@/onenetwork/components/datatable/DateTimeCell.vue'
import { uuid } from 'vue3-uuid'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant.ts'
import BrokerAPI from '../constants/broker.api.uri.const'
import { formatTableDataBrokerApprove } from '../helper/table'
import { buildFilterObject } from '@/utils/filter'
import {markRaw} from 'vue'
import PhoneCell from '@/onenetwork/components/datatable/PhoneCell.vue'
import RegionComponent from '@/modules/broker/components/RegionComponent.vue'

export interface tabItem {
  id: string,
  label: string,
  active: boolean,
}

export enum BrokerApprovalListActionTypes {
  FILTERING = 'FILTERING',
  PENDING= "PENDING",
  FETCHING= "FETCHING",
  FETCH_SUCCESS = "FETCH_SUCCESS",
  FETCH_FAILURE = "FETCH_FAILURE",
}

interface BrokerApprovalListStore {
  action_type: BrokerApprovalListActionTypes,
  action_mess: string,
  uuid: string,
  data: Object,
  filter: Array<{
    key: string,
    type: string,
    label: string,
    placeholder: string,
    value: any,
    options?: Array<{label: string, value: string}>
  }>,
  pageSize: number,
  page: number,
  tabs: Array<any>,
  tableConfig: any,
  selectedIds: Array<string|number>,
}

export const useBrokerApprovalListStore = defineStore('broker.approval.list', {
  state: (): BrokerApprovalListStore => ({
    action_type: BrokerApprovalListActionTypes.PENDING,
    action_mess: "",
    uuid: '',
    data: {
      list: [],
      totalRecords: 0,
      totalPage: 0,
    },
    filter: [
      {
        key: 'code',
        type: 'text',
        label: 'Mã tài khoản',
        placeholder: 'Nhập mã tài khoản',
        value: '',
      },
      {
        key: 'keyword',
        type: 'taginput',
        label: 'Lọc theo từ khoá',
        placeholder: 'Nhập từ khoá',
        value: '',
      },
      {
        key: 'business_type',
        type: 'select-multiple',
        label: 'Loại môi giới',
        placeholder: 'Chọn loại môi giới',
        value: '',
        options: [
          { label: 'Cá nhân', value: 'invidual' },
          { label: 'Công ty', value: 'company' },
        ],
      },
      {
        key: 'province_id',
        type: 'region-level-1',
        label: 'Lọc theo tỉnh/thành',
        placeholder: 'Chọn phường xã',
        value: '',
        options: null,
      },
      {
        key: 'ward_id',
        type: 'region-level-2',
        label: 'Lọc theo phường / xã',
        placeholder: 'Chọn phường xã',
        value: '',
        options: null,
      },
      {
        key: 'higher_broker_id',
        type: 'account-broker-selector',
        label: 'Lọc theo cấp trên',
        placeholder: 'Chọn cấp trên',
        value: '',
        options: null,
      },
      {
        key: 'registerDate',
        type: 'date-range',
        label: 'Lọc theo ngày đăng ký',
        placeholder: 'Chọn ngày đăng ký',
        value: '',
      },
    ],
    pageSize: 10,
    page: 1,
    tabs: [
      {
        id: 'list',
        label: 'Danh sách chờ phê duyệt',
        active: true,
      }
    ],
    tableConfig: {
      canShowHide: true,
      columns: {
        code: { label: 'CODE', component: markRaw(TextCell), class: '', visible: true, sort: false, config: {} },
        created_at: { label: 'Ngày đăng ký', component: markRaw(DateTimeCell), class: '', visible: true, sort: 'desc', config: {} },
        avatar: { label: 'Ảnh', component: markRaw(ThumbCell), class: '', visible: true, sort: false, config: {width: '40px', height: '40px', borderRadius: '4px'} },
        phone: { label: 'SDT', component: markRaw(PhoneCell), class: '', visible: true, sort: false, config: {} },
        full_name: { label: 'Tên', component: markRaw(TextCell), class: '', visible: true, sort: false, config: {} },
        regions: { label: 'Khu vực', component: markRaw(RegionComponent), class: '', visible: true, sort: false, config: {} },
        birthday: { label: 'Ngày sinh', component: markRaw(TextCell), visible: true, sort: false, config: {} },
        business_type: { label: 'Loại MG', component: markRaw(TextCell), class: '', visible: true, sort: false, config: {} },
      }
    },
    selectedIds: []
  }),
  getters: {
    sortFilter: state => {
      const sort: any = []
      if(Object.keys(state.tableConfig?.columns).length>0){
        Object.keys(state.tableConfig?.columns).forEach(col => {
          if(state.tableConfig.columns[col].sort) {
            sort.push([col, state.tableConfig.columns[col].sort])
          }
        })
      }
      return sort
    }
  },
  actions: {
    //TAB ACTION
    changeTab (targetId: string) {

      for (const tab of this.tabs) {
        tab.active = (tab.id === targetId)
      }
    },
    closeTab (targetId: string) {

      const index = this.tabs.findIndex(tab => tab.id === targetId)


      if (index !== -1) {
        this.tabs.splice(index, 1)
      }
    },
    closeAllTab () {
      this.tabs = [{
        id: 'list',
        label: 'Danh sách chờ phê duyệt',
        active: true,
      }]
    },
    newTab (item: tabItem) {
      const exists = this.tabs.some(tab => tab.id === item.id)
      if (!exists) {
        this.tabs.push(item)
      }
      this.changeTab(item.id)
    },

    //FILTER ACTION
    setFilter (filter: any) {
      this.filter = filter
      this.page = 1
      this.action_type = BrokerApprovalListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },
    changeFilter (key: string, value: any) {
      const filterItem = this.filter.find((item: {key: string}) => item.key === key)
      if (filterItem) {
        filterItem.value = value
        this.page = 1
        this.action_type = BrokerApprovalListActionTypes.FILTERING
        this.uuid = uuid.v4()
      }
    },
    resetFilter () {
      //reset filter province_id, district_id, broker_level
      this.filter = this.filter.map(item => ({...item, value: ''}))
      this.page = 1
      this.action_type = BrokerApprovalListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    //PAGE ACTION
    changePage (page: number) {
      this.page = page
      this.action_type = BrokerApprovalListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },
    changePageSize (size: number) {
      this.pageSize = size
      this.action_type = BrokerApprovalListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    //TABLE CONFIG ACTION
    toggleColumnVisibility(columnCode: string, visible: boolean) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].visible = visible
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },
    toggleSort(columnCode: string, sort: string) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].sort = sort
        this.action_type = BrokerApprovalListActionTypes.FILTERING
        this.uuid = uuid.v4()
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },

    //DATA ACTION
    async fetchList(){
      return new Promise(async (resolve, reject) => {
        try{
          this.action_type = BrokerApprovalListActionTypes.FETCHING
          const sort = this.sortFilter
          const pagination = {
            page: this.page,
            page_size: this.pageSize,
            sort
          }

          const filter = buildFilterObject(this.filter, pagination)
          const res = await APIClient.get(BrokerAPI.broker.request_approval, {
            params: filter
          })
          const { data } = res.data
          this.data = {
            list: formatTableDataBrokerApprove(data.data) || [],
            totalRecords: data.total || 0,
            totalPage: data.last_page || 0,
          }
          // console.log(261, this.data)
          this.action_type = BrokerApprovalListActionTypes.FETCH_SUCCESS
          resolve(res)
        } catch (e) {
          this.action_type = BrokerApprovalListActionTypes.FETCH_FAILURE
          reject(e)
        }
      })
    }
  }
})
